import { Box } from '@mui/material';
import React, { createContext } from 'react';
import {
  ControllerFieldState,
  ControllerRenderProps,
  FieldValues,
  useController,
} from 'react-hook-form';

type DisplayInformationFieldProviderProps = {
  name: string;
  children: React.ReactNode;
  displayFieldSetDefaultValue?: any;
};

type DisplayInformationFieldContextType = {
  field: ControllerRenderProps<FieldValues, string>;
  fieldState: ControllerFieldState;
  displayFieldSetDefaultValue: any;
};

export const DisplayInformationFieldContext = createContext<
  DisplayInformationFieldContextType | undefined
>(undefined);

const DisplayInformationFieldProvider = ({
  name,
  children,
  displayFieldSetDefaultValue,
}: DisplayInformationFieldProviderProps) => {
  const { field, fieldState } = useController({ name });

  return (
    <DisplayInformationFieldContext.Provider
      value={{
        field,
        fieldState,
        displayFieldSetDefaultValue,
      }}
    >
      <Box ref={field.ref} tabIndex={0} />
      {children}
    </DisplayInformationFieldContext.Provider>
  );
};

export default DisplayInformationFieldProvider;
